import React from 'react';
import { GridItem, Image} from '@chakra-ui/react';
import thalamuslogo from './../../TopBar/thalamuslogo.svg';
import { useNavigate } from 'react-router-dom';

const TopLeft = () => {
    const navigate = useNavigate();
    return (
      <GridItem 
        area="image" 
        bg="white" 
        display="flex" 
        alignItems="top" 
        justifyContent="left"
        minW={"50%"}
        minH={"50px"}
        marginLeft={"24px"}
      >
        <img 
          onClick={() => navigate('/')}
          src={thalamuslogo} 
          style={{ 
            height: ['32px', ' 40px', '48px'], // Responsive height for different breakpoints
            cursor: 'pointer',
            width: ['210px'],
          }}
        />
          {/* <Image
            src={thalamuslogo}
            alt="Placeholder Image"
            boxSize="74%"
            objectFit="fill"
            minW={"50%"}
            height={"60px"}
            // minH={"30px"}
          /> */}
      </GridItem>
    )
}

export default TopLeft;